import { useState } from 'react'

import '../styles/questions.css'
import { FaPlus, FaMinus } from "react-icons/fa6";

const Questions = () => {
    const [aActive, setAActive] = useState(false);
    const [bActive, setBActive] = useState(false);
    const [cActive, setCActive] = useState(false);
    const [dActive, setDActive] = useState(false);
    const [eActive, setEActive] = useState(false);
  return (
    <>
      <div className="questions">
        <h6>COMMON QUESTIONS</h6>
        <ul>
          <li onClick={(e) => setAActive(!aActive)}>
            { aActive ? <FaMinus /> : <FaPlus />}
            <h3>Do I need a trading experience? </h3>
            <p className={' ' + (aActive ? ' active' : ' inactive')}>No. The signals tell you exactly when to enter and exit — just follow the alerts.</p>
          </li>
          <li onClick={(e) => setBActive(!bActive)}>
            { bActive ? <FaMinus /> : <FaPlus />}
            <h3>Does it work on all devices?</h3>
            <p className={' ' + (bActive ? ' active' : ' inactive')}>Yes. Summit Capital  runs on TradingView, which is available on iPhone, Android, Mac, Windows, and any browser. 
              Whether you trade from your phone on the go or from a desktop setup at home, the signals show up the same way everywhere. 
              You get BUY/SELL markers directly on your charts and instant push notifications to your phone so you never miss an alert, 
              no matter what device you're on.</p>
          </li>
          <li onClick={(e) => setCActive(!cActive)}>
            { cActive ? <FaMinus /> : <FaPlus />}
            <h3>What market does it cover?</h3>
            <p className={' ' + (cActive ? ' active' : ' inactive')}>Stocks, crypto, forex, and commodities — any market available on TradingView.</p>
          </li>
          <li onClick={(e) => setDActive(!dActive)}>
            { dActive ? <FaMinus /> : <FaPlus />}
            <h3>How are signals delivered?</h3>
            <p className={' ' + (dActive ? ' active' : ' inactive')}>BUY/SELL markers appear on your chart. You can also push alerts to your phone or Discord in real time.</p>
          </li>
          <li onClick={(e) => setEActive(!eActive)}>
            { eActive ? <FaMinus /> : <FaPlus />}
            <h3>What do I need to get started?</h3>
            <p className={' ' + (eActive ? ' active' : ' inactive')}>A free TradingView account and a Summit Capital  subscription. Access is granted within minutes of signing up.</p>
          </li>
        </ul>
      </div>
    </>
  )
}

export default Questions